import React, { useEffect, useState } from 'react';
import { Chip, Grow, hexToRgb } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTheme } from '@mui/material/styles';

const useStyles = makeStyles()({
  root: {
    background: '#fff',
    color: '#000000ba',
    height: 'fit-content',
    minWidth: 70,
    textAlign: 'center',
    fontSize: '13px',
    width: '100%'
  },
  label: {
    whiteSpace: 'break-spaces',
    padding: '3px 12px'
  }
});

const AdviserInfoTagChip = props => {
  const { color, isIntoView, filled, ...rest } = props;

  const [isIn, setIsIn] = useState(false);
  const { classes } = useStyles();
  const theme = useTheme();
  const RGB = hexToRgb(color || theme.palette.primary.main)
    .replace('rgb', 'rgba')
    .replace(')', ', 0.8)');

  // useEffect(() => {
  //   const timeoutId = setTimeout(() => {
  //     setIsIn(true);
  //   }, 500);
  //
  //   return () => {
  //     clearTimeout(timeoutId);
  //   };
  // }, []);

  useEffect(() => {
    setIsIn(false);

    if (isIntoView) {
      const timeoutId = setTimeout(() => {
        setIsIn(true);
      }, 150);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [isIntoView]);

  const style = {
    boxShadow: `rgb(0 0 0 / 12%) 0px 0px 2px, ${RGB} 2px 2px 5px 0px`
  };
  if (filled) {
    style.background = filled;
    style.color = 'white';
  }
  return (
    <Grow in={isIn} timeout={{ appear: 200, enter: 600, exit: 0 }}>
      <Chip color="primary" style={style} classes={classes} {...rest} />
    </Grow>
  );
};

export default AdviserInfoTagChip;
